exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".neighbors-index[data-v-16d65cc4]{width:1114px;height:200px;margin:0 auto}.neighbors-index-content img[data-v-16d65cc4]{width:100%;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16d65cc4","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/ads/AdNeighbors.vue
// module id = 0cm2
// module chunks = 183